export function defaultContact() {
    return {
        customerId: null,
        firstName: "",
        lastName: "",
        email: "",
        companyName: "",
        contact_method: "email",
        phone: "",
        is_staff: false,
        tripCode: "",
        fishTag: "",
        licenseNumber: "",
        prepaidAmount: "0",
        /** @type {File | null} */
        licenseFile: null,
        /** @type {File | null} */
        licenseFileFront: null,
        /** @type {File | null} */
        licenseFileBack: null,
        /** Existing server path for license front (round-trip / clear on update_customer_fields). */
        licenseFrontImg: null,
        /** Existing server path for license back. */
        licenseBackImg: null,
        ship_to: null,
        default_ship_id: null,
        bill_to: null,
        default_bill_id: null,
        bill_same_as_ship: false,
        subscribe_newsletter: false,
        termsAccepted: false,
        /** When true with a selected customerId, backend updates that customer's contact fields. */
        updateCustomerFields: false,
        /** Snapshot of contact fields when a customer was last selected; used for edit/undo UI. */
        contactBaseline: null,
        /**
         * Frozen display name of the selected DB customer for the search bar.
         * Not updated when the form first/last name fields change.
         */
        selectedCustomerLabel: null,
    }
}

export function defaultDelivery() {
    return {
        method: "ship",
        /** @type {number | null} */
        pickupLocationId: null,
        holdForPickup: false,
    }
}

export function defaultShipping() {
    return {
        shippingCustomerId: null,
        /** `default_ship_id` of the selected shipping customer; drives `src_ship_id`. */
        defaultShipAddressId: null,
        addressDirty: false,
        /**
         * When true, backend attaches ship_to as the customer's default (src_ship_id cleared).
         * Default yes for manual entry; default no when updating an existing customer address.
         */
        attachAddressToCustomer: true,
        /** Snapshot of address fields when a shipping customer/address was last loaded. */
        addressBaseline: null,
        firstName: "",
        lastName: "",
        companyName: "",
        email: "",
        country: "",
        province: "",
        city: "",
        streetAddress: "",
        postalCode: "",
        phone: "",
    }
}

export function defaultBilling() {
    return {
        useShippingAddress: false,
        billingCustomerId: null,
        /** @type {number | null} */
        defaultBillAddressId: null,
        /** Set when billing address fields are edited after a customer load. */
        addressDirty: false,
        /**
         * When true, backend attaches bill_to as the customer's default (src_bill_id cleared).
         * Default yes for manual entry; default no when updating an existing customer address.
         */
        attachAddressToCustomer: true,
        /** Snapshot of address fields when a billing customer/address was last loaded. */
        addressBaseline: null,
        firstName: "",
        lastName: "",
        companyName: "",
        email: "",
        country: "",
        province: "",
        city: "",
        streetAddress: "",
        postalCode: "",
        phone: "",
    }
}

export function defaultProcessing() {
    return {
        totalWeight: "",
        containers: "",
        fresh: false,
        frozen: true,
        instructions: [
            {
                /** @type {number | null} */
                speciesId: null,
                /** @type {number | null} */
                processId: null,
                quantity: 0,
                unit: "Whole Fish",
                additionalNotes: "",
            },
        ],
        /** Option selections keyed by option id (from `app.options`). */
        options: {},
    }
}

/**
 * @param {string} dateYyyyMmDd
 */
export function defaultDropoff(dateYyyyMmDd) {
    return {
        /** @type {number | null} */
        locationId: null,
        date: dateYyyyMmDd,
    }
}

